import React, { FC } from 'react';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import { Alert } from '@material-ui/lab';

import { EditButton } from '..';
import Confirmation from '../Confirmation';
import { useUnlinkProfile } from '~/hooks/apiIdentity';
import { useApiIdentityTranslate } from '.';

interface Props {
  identityId: string | undefined;
  profileId: string | undefined;
  className?: string;
}

const UnlinkProfileAction: FC<Props> = (props) => {
  const { className, identityId, profileId } = props;
  const t = useApiIdentityTranslate();

  const unlinkProfileMutation = useUnlinkProfile();
  const handleUnlink = () => {
    if (identityId && profileId) {
      return unlinkProfileMutation.mutateAsync({ identityId, profileId });
    }
  };

  return (
    <Confirmation
      onConfirm={handleUnlink}
      confirmButtonProps={{ loading: unlinkProfileMutation.isLoading }}
      confirmationSettings={{
        variant: 'modal',
        modal: { content: <Alert severity='warning'>{t('unlinkProfileWarning')}</Alert> },
      }}
    >
      <EditButton className={className} label={t('unlinkProfile')} icon={<LinkOffIcon />} red />
    </Confirmation>
  );
};

export default UnlinkProfileAction;
